import { CalendarEntities } from '@app/pcs/models/calendar';
import { PathSectionsEntities } from '@dossier/models/path-section';
import { RuImPair, ruImPairAgencies } from '@dossier/models/ru-im-pair';
import { processStrategyForChild, processStrategyForParent } from '@dossier/models/schema-process-strategy';
import {
  SubPath,
  subPathForEdit,
  SubPathsEntities,
  subPathsSchema,
  subPathWithBaseTrainParameters,
  SubPathWithBlocks,
  subPathWithTrainParameters
} from '@dossier/models/sub-path';
import {gql} from 'apollo-angular';
import { schema } from 'normalizr';

export interface BaseTerritory {
  id?: number;
  responsiblePair?: RuImPair;
  warning?: string;
}

export interface TerritoryWithBlocks extends BaseTerritory {
  subPaths: SubPathWithBlocks[];
}

export interface Territory extends BaseTerritory {
  subPaths: SubPath[];
}

export interface TerritoryEntity extends BaseTerritory {
  timetableId: number;
  subPaths: number[];
}

export interface TerritoryEntities {
  [key: number]: TerritoryEntity;
}

export interface NormalizedTerritory {
  entities: {
    territories: TerritoryEntities;
    subPaths: SubPathsEntities;
    pathElements: PathSectionsEntities;
    calendar: CalendarEntities;
  };
  result: number;
}

export const territorySchema = new schema.Entity('territories', {
  subPaths: [subPathsSchema]
}, {
  idAttribute: 'id',
  processStrategy: processStrategyForParent
});

export const territoriesSchema = new schema.Entity('territories', {
  subPaths: [subPathsSchema]
}, {
  idAttribute: 'id',
  processStrategy: processStrategyForChild('timetable')
});

export const timetableTerritory = gql`
    fragment timetableTerritory on Territory {
        id
        persistedId
        warning
        responsiblePair {
            ...ruImPairAgencies
        }
        subPaths {
            ...subPathWithTrainParameters
        }
    }
    ${ruImPairAgencies}
    ${subPathWithTrainParameters}
`;

export const territoryWithBaseTrainParameters = gql`
    fragment territoryWithBaseTrainParameters on Territory {
        id
        persistedId
        warning
        responsiblePair {
            ...ruImPairAgencies
        }
        subPaths {
            ...subPathWithBaseTrainParameters
        }
    }
    ${ruImPairAgencies}
    ${subPathWithBaseTrainParameters}
`;

export const territoryWarning = gql`
    fragment territoryWarning on Territory {
        id
        persistedId
        warning
        subPaths {
            id
            warning
            pathElements {
              id
              persistedId
              alternativeOrigin
              alternativeDestination
            }
        }
    }
`;

export const territoryForEdit = gql`
    fragment territoryForEdit on Territory {
        id
        persistedId
        responsiblePair {
            ...ruImPairAgencies
        }
        subPaths {
            ...subPathForEdit
        }
    }
    ${ruImPairAgencies}
    ${subPathForEdit}
`;
